import { useMemo, useState } from "react";
import { featuredQuotes, moodTags } from "@/mocks/quotes";

const moodLabel = (key: string) =>
  moodTags.find((m) => m.key === key)?.label ?? "心情";

export default function QuoteCollection() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      active === "all"
        ? featuredQuotes
        : featuredQuotes.filter((q) => q.mood === active),
    [active],
  );

  return (
    <section id="quotes" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-16">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs tracking-widest text-primary-600 uppercase">Featured Quotes</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            精选伤感文案与心情语录
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            按心情挑一句读。点下面的标签就能筛选出此刻和你最接近的那一类文字，
            筛选只作用于本站已有的内容，不会跳转或加载其它页面。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2" role="tablist" aria-label="心情标签筛选">
          {moodTags.map((tag) => {
            const isActive = active === tag.key;
            return (
              <button
                key={tag.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(tag.key)}
                className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tag.label}
              </button>
            );
          })}
        </div>

        <p className="mt-5 text-xs text-foreground-500">
          共 {list.length} 条 · 当前分类：{moodTags.find((m) => m.key === active)?.label}
        </p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((q, index) => (
            <article
              key={q.id}
              className="group flex flex-col justify-between rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-primary-200 transition-colors"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="font-heading text-sm text-primary-600/70">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs">
                    {moodLabel(q.mood)}
                  </span>
                </div>
                <p className="mt-5 font-heading text-base md:text-lg leading-loose text-foreground-900">
                  {q.text}
                </p>
              </div>
              <p className="mt-6 pt-4 border-t border-background-200/70 text-xs text-foreground-500 flex items-center gap-1.5">
                <i className="ri-quill-pen-line"></i>
                {q.scene}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}